import Http from "./Http";

export default class SampleService extends Http {
  async addReceivedButNotActivatedSample(IHProductId) {
    return await this.post(`/samples/receivedByLab/notActivated`, { IHProductId });
  }

  async getReceivedButNotActivatedSamples(params = {}) {
    const { limit = 10, offset = 0, orderBy, orderType, query } = params;
    const queryParams = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString(),
      ...(orderBy && { orderBy }),
      ...(orderType && { orderType }),
      ...(query && { query })
    });
    return await this.get(`/samples/receivedByLab/notActivated?${queryParams}`);
  }

  async deleteReceivedButNotActivatedSample(IHProductId) {
    return await this.delete(`/samples/receivedByLab/notActivated`, { data: { IHProductId } });
  }

  async getAllSamples(params = {}) {
    const { 
      limit = 10, 
      offset = 0, 
      orderBy, 
      orderType, 
      query,
      filterField,
      filterValue,
      filterFields,
      filterValues,
      activatedAtFrom,
      activatedAtTo
    } = params;
    const queryParams = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString(),
      ...(orderBy && { orderBy }),
      ...(orderType && { orderType }),
      ...(query && { query }),
      ...(filterField && { filterField }),
      ...(filterValue && { filterValue }),
      ...(activatedAtFrom && { activatedAtFrom }),
      ...(activatedAtTo && { activatedAtTo })
    });
    
    if (filterFields && Array.isArray(filterFields)) {
      filterFields.forEach(field => {
        queryParams.append('filterFields[]', field);
      });
    }
    
    if (filterValues && Array.isArray(filterValues)) {
      filterValues.forEach(value => {
        queryParams.append('filterValues[]', value);
      });
    }
    
    return await this.get(`/samples?${queryParams}`);
  }

  async updateSample(sampleId, data) {
    return this.patch(`/samples/${sampleId}`, data);
  }
}
